//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../../components/helpers.js'
import ReadonlyDocumentsField from '../../../components/File/ReadonlyDocumentsField.vue'

export default {
  components: {
    ReadonlyDocumentsField
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    withoutServiceObject: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      images: [],

      convertTimeReactive: convertTime,
      imagesExpanded: false
    }
  },
  computed: {
    executorText: function () {
      let executorText = ''
      if (this.report.brigadeName) {
        executorText += this.report.brigadeName

        if (this.report.brigadeEmployees) {
          const brigadeEmployeesNames = this.report.brigadeEmployees.map(employee => {
            const employeeFio = employee.fio.split(' ')
            if (employeeFio[1]) {
              employeeFio[1] = employeeFio[1].slice(0, 1) + '.'
            }
            if (employeeFio[2]) {
              employeeFio[2] = employeeFio[2].slice(0, 1) + '.'
            }
            return employeeFio.join(' ')
          })
          executorText += ' (' + brigadeEmployeesNames.join(', ') + ')'
        }
      } else if (this.report.executor) {
        executorText = this.report.executor.fio
      }

      return executorText
    }
  },
  created: function () {
    if (this.report.documents != null) {
      const images = []
      for (const document of this.report.documents) {
        if (this.isImage(document.contentType)) {
          images.push({
            id: document.id,
            name: this.report.name + '-' + (images.length + 1) + '.' + document.contentType.split('/')[1]
          })
        }
      }
      this.images = images
    }
  },
  methods: {
    isImage: function (str) {
      return str != null && str.startsWith('image/')
    }
  }
}

